const PageState = {
    View: 0,
    Add: 1,
    Edit: 2,
    See: 3
};

export default PageState;